import React from "react";
import { Input } from "reactstrap";
import styled from "styled-components";
import PropTypes from "prop-types";
import { Devices } from "../../../../../../styles";

const InputContainer = styled.div`
  width: 100%;
  @media ${Devices.desktop} {
    width: 130px;
  }
  position: relative;
`;

const PLACEHOLDER_COLOR = "#808080";
const ACTIVE_COLOR = "#333333";

const Select = styled(Input)`
  color: ${(props) => (props.$active ? ACTIVE_COLOR : PLACEHOLDER_COLOR)};
`;

const InputSelect = React.memo(
  ({
    placeholder,
    name,
    register,
    options,
    hasValue,
    loading,
    ...restProps
  }) => {
    const renderOption = (option) => {
      return (
        <option key={option?.value ?? option} value={option?.value ?? option}>{option?.label ?? option}</option>
      );
    };

    const placeholderOption = (
      <option value="" disabled>
        {placeholder}
      </option>
    );

    const loadingOption = loading && (
      <option value="" disabled>
        Loading data...
      </option>
    );

    return (
      <InputContainer>
        <Select type="select" $active={hasValue} name={name} {...restProps}>
          {placeholderOption}
          {loadingOption}
          {options.map(renderOption)}
        </Select>
      </InputContainer>
    );
  }
);

InputSelect.propTypes = {
  placeholder: PropTypes.string,
  name: PropTypes.string,
  register: PropTypes.func,
  options: PropTypes.array,
  hasValue: PropTypes.bool,
  loading: PropTypes.bool,
};

InputSelect.defaultProps = {
  options: [],
  hasValue: false,
  loading: false,
};

export default InputSelect;
